import { createAction } from 'typesafe-actions';
import { AuthDto } from '../dtos/auth';

export const userLoggedIn = createAction('USER_LOGIN')<AuthDto>();
export const userLoginFail = createAction('USER_LOGIN_FAIL')<AuthDto>();
export const userXsrfToken = createAction('USER_XSRF_TOKEN')<string>();
export const tenantAction = createAction('USER_TENANT')<string>();
